import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Testata from "../../components/Testata/Testata";
import imgTestata from "../../assets/testate/testata2.jpg";

const Realizzazioni = () => {
  const [featuredPosts, setFeaturedPosts] = useState([]);

  useEffect(() => {
    fetch("http://dev18.makemedia.it/wp/wp-json/wp/v2/posts/?_embed&per_page=10")
      .then((res) => res.json())
      .then((res) => setFeaturedPosts(res));
  }, []);

  return (
    <div>
      <Testata titolo="Realizzazioni" imgurl={imgTestata} />
      <div className="pt pb">
        <div className="container">
          <div className="intro text-center">
            <h2 className="mb0">Alcuni dei nostri ultimi lavori</h2>
          </div>
          <div className="featured__list mt2">
            {featuredPosts.map((featuredPost) => {
              // console.log(featuredPost);
              let featuredImg =
                featuredPost._embedded["wp:featuredmedia"]["0"].source_url;
              return (
                <div className="featured__item" key={featuredPost.id}>
                  <div className="featured__inner">
                    <Link to={`/realizzazioni/${featuredPost.id}`}>
                      <div className="featured__thumb">
                        <img
                          src={featuredImg}
                          alt={featuredPost.title.rendered}
                        />
                      </div>
                      <div className="featured__title">
                        {featuredPost.title.rendered}
                      </div>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Realizzazioni;
